const WORDS = "OVER 1,000,000 PREVENTATIVE MAINTENANCE SERVICES PERFORMED NATIONWIDE";

export default function Marquee() {
  return (
    <div className="relative border-y border-mm-green/20 bg-mm-base py-6 sm:py-8 overflow-hidden" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center shrink-0" aria-hidden={k === 1}>
            {Array.from({ length: 4 }).map((_, i) => (
              <span key={i} className="flex items-center">
                <span className="font-heading font-black uppercase text-4xl sm:text-6xl tracking-tight text-stroke px-8">
                  {WORDS}
                </span>
                <span className="text-mm-green text-4xl sm:text-6xl px-2">✕</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
